/** Drop every service worker and its caches. Used by dev HMR and the native shell. */
export async function unregisterServiceWorkers(): Promise<void> {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
  } catch {
    // ignore — best-effort cleanup
  }

  if (typeof caches === "undefined") return;
  try {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  } catch {
    // ignore
  }
}

/**
 * DEV-only: unregister leftover Service Workers / Cache Storage from prior
 * `yarn preview` or production builds that were served on the same origin.
 * Prevents stale shell while Vite HMR is supposed to be live.
 */
export async function clearDevServiceWorkers(): Promise<void> {
  if (!import.meta.env.DEV) return;
  await unregisterServiceWorkers();
}
